import { today } from "App/utils/helpers";

export const RESET_STATE_SPRI = {
  nomor_spri: "",
  nomor_kartu: "",
  kode_dokter: null,
  nama_dokter: "Pilih Dokter",
  kode_poliklinik: null,
  nama_poliklinik: "Pilih Poliklinik",
  tgl_rencana_kontrol: today(),
};
